import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import UserDetail from './pages/UserDetail';
import Schools from './pages/Schools';
import SchoolDetail from './pages/SchoolDetail';
import Courses from './pages/Courses';
import CourseDetail from './pages/CourseDetail';
import Certificates from './pages/Certificates';
import Profile from './pages/Profile';
import LessonEditor from './pages/LessonEditor';
import ExamEditor from './pages/ExamEditor';
import Districts from './pages/Districts';
import DistrictDetail from './pages/DistrictDetail';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/certificates"
            element={
              <ProtectedRoute allowedRoles={['ADMIN', 'SCHOOL_ADMIN', 'DISTRICT']}>
                <Certificates />
              </ProtectedRoute>
            }
          />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute allowedRoles={['ADMIN', 'SCHOOL_ADMIN', 'DISTRICT']}>
                <Users />
              </ProtectedRoute>
            }
          />
          <Route
            path="/users/:id"
            element={
              <ProtectedRoute allowedRoles={['ADMIN', 'SCHOOL_ADMIN', 'DISTRICT']}>
                <UserDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/schools"
            element={
              <ProtectedRoute allowedRoles={['ADMIN', 'SCHOOL_ADMIN', 'DISTRICT']}>
                <Schools />
              </ProtectedRoute>
            }
          />
          <Route
            path="/districts"
            element={
              <ProtectedRoute allowedRoles={['ADMIN']}>
                <Districts />
              </ProtectedRoute>
            }
          />
          <Route
            path="/districts/:id"
            element={
              <ProtectedRoute allowedRoles={['ADMIN']}>
                <DistrictDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/schools/:id"
            element={
              <ProtectedRoute allowedRoles={['ADMIN', 'SCHOOL_ADMIN', 'DISTRICT']}>
                <SchoolDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/courses"
            element={
              <ProtectedRoute allowedRoles={['ADMIN']}>
                <Courses />
              </ProtectedRoute>
            }
          />
          <Route
            path="/courses/:courseId/exam/edit"
            element={
              <ProtectedRoute allowedRoles={['ADMIN']}>
                <ExamEditor />
              </ProtectedRoute>
            }
          />
          <Route
            path="/courses/:id"
            element={
              <ProtectedRoute allowedRoles={['ADMIN', 'SCHOOL_ADMIN', 'DISTRICT']}>
                <CourseDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute allowedRoles={['ADMIN', 'SCHOOL_ADMIN', 'DISTRICT']}>
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/lessons/:lessonId/edit"
            element={
              <ProtectedRoute allowedRoles={['ADMIN']}>
                <LessonEditor />
              </ProtectedRoute>
            }
          />
          <Route
            path="/modules/:moduleId/lessons/new"
            element={
              <ProtectedRoute allowedRoles={['ADMIN']}>
                <LessonEditor />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;

